import React from "react";

const LAYERS = [
  ["OPERATOR INTELLIGENCE", "supervision · override · control room"],
  ["MACHINE AUTONOMY", "perceive · plan · act, on the machine"],
  ["MACHINE OS", "runtime · updates · fleet coordination"],
  ["MACHINE DATA ENGINE", "collect · simulate · validate · improve"],
  ["YOUR SITE · YOUR INFRASTRUCTURE · YOUR KEYS", "access granted by the owner, revoked by the owner"],
];

// FIG.1 The sovereign machine stack, in the Enterprise 2 code-figure idiom.
export function MachineStackFigure() {
  return (
    <div className="e2-fig-code" data-testid="m2-stack-figure" role="region" aria-label="The sovereign machine stack">
      <div className="e2-fig-code-head">
        <span>crowther@site&nbsp;·&nbsp;~/stack</span>
        <span>sovereign-machine.stack</span>
      </div>
      <div className="e2-fig-code-body">
        <div className="e2-fig-code-comment">$ cat sovereign-machine.stack</div>
        <hr className="e2-fig-code-sep" />
        {LAYERS.map(([name, verbs], i) => (
          <div key={name} className={`m2-stack-layer${i === LAYERS.length - 1 ? " base" : ""}`} data-testid={`m2-stack-layer-${i + 1}`}>
            <span className="m2-stack-name">{name}</span>
            <span className="m2-stack-verbs">{verbs}</span>
          </div>
        ))}
        <hr className="e2-fig-code-sep" />
        <div className="e2-fig-code-comment">$ stack.verify</div>
        <div className="m2-stack-ok"><span className="ok">ok</span> every layer runs where the work happens.</div>
        <div className="m2-stack-ok"><span className="ok">ok</span> the bottom line is the permission model, not a slogan.</div>
      </div>
      <div className="e2-fig-code-foot">
        <span>5 layers &nbsp;·&nbsp; on site</span>
        <span>your keys, your machines</span>
      </div>
    </div>
  );
}
